import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { PopupService } from "../../services/shared/popup.service";
import { CarrierService } from "../../services/carrier.service";
import { ApplicationService } from "../../services/application.service";
import { PermitService } from "../../services/permit.service";
import { AuthWebService } from "app/services/authweb.service";
import { VehicleService } from "../../services/vehicle.service";
import { environment } from "../../../environments/environment";
import { AppVehicleComponent } from "../../permits/permit-application/shared/app-vehicle/app-vehicle.component";
import { UtilityServiceService } from "../../services/utility-service.service";
import { ToastrService } from "ngx-toastr";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CurrencyFormat } from "app/pipes/currencyFormat.pipe";

@Component({
  selector: "permit-viewer",
  templateUrl: "./permit-viewer.component.html",
  styleUrls: ["./permit-viewer.component.css"],
  providers: [CurrencyFormat],
})
export class PermitViewerComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;

  @ViewChild(AppVehicleComponent) vehicleComp: AppVehicleComponent;

  dataCntrl: any = {
    carrierID: -1,
    permittypeSelected: false,
    selectedtype: "",
    disableTypes: false,
    processStarted: false,
    currentTab: "",
    formValid: false,
    isViewEditControl: false,
    carrier: {},
    application: {},
    permit: {},
    permittype: {},
    vehicles: [],
    permitTypesDocLinks: [],
  };
  StartComplete: boolean;
  VehicleComplete: boolean;
  canSave: boolean;
  canSubmit: boolean;
  pageload: boolean;
  tabload: boolean;

  activeTab = "permitype";
  disableTabs: boolean = true;
  myreference: "";
  username: any;
  iconCtrl = 1;
  disableBtn: boolean = false;
  isProcess: boolean = false;
  showMenuBtn: boolean = false;
  showPage: boolean;
  message = "Loading, please wait...";
  isLoading: boolean = false;
  isDupApplication: boolean = false;
  routeDetials;
  carrierId: any;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private showModal: PopupService,
    private carrierService: CarrierService,
    public currformat: CurrencyFormat,
    private authWebService: AuthWebService,
    public applicationService: ApplicationService,
    public permitService: PermitService,
    public vehicleService: VehicleService,
    public utility: UtilityServiceService,
    private toastService: ToastNotificationService,
    private toastr: ToastrService,
    private routr: Router
  ) {}

  ngOnInit() {
    this.activeRoute.queryParamMap.subscribe((params) => {
      this.carrierId = +params.get("carrierId") || null;
    });
    this.routeDetials = this.routr.url.split("/")[5];
    this.dataCntrl.currentTab = "permitype";
    this.utility.activeTab = 1;
    this.utility.currentActive = 1;
    this.utility.permitType = "permittype";
    this.utility.isView = false;
    if (this.router.url.indexOf("edit") < 0) {
      if (environment.authWebApi.userData.Roles.find((p) => p.Code != "RGT")) {
        this.activeRoute.params.subscribe((params: Params) => {
          this.dataCntrl.carrierID = params["id"];
        });
        this.dataCntrl.currentTab = "permitype";
        //this.getCarrier();
        if (
          environment.authWebApi.userData != null &&
          environment.authWebApi.userData != undefined &&
          environment.authWebApi.userData.hasOwnProperty("user")
        ) {
          this.username = environment.authWebApi.userData.User.Username;
        }
      }

      if (
        environment.authWebApi.userData.Roles.find((p) => p.Code != "ADMIN")
      ) {
        this.activeRoute.params.subscribe((params: Params) => {
          this.dataCntrl.carrierID = params["id"];
        });
        this.dataCntrl.currentTab = "permitype";
        //this.getCarrier();
        if (
          environment.authWebApi.userData != null &&
          environment.authWebApi.userData != undefined &&
          environment.authWebApi.userData.hasOwnProperty("user")
        ) {
          this.username = environment.authWebApi.userData.User.Username;
        }
      }
    }
    if (this.router.url.indexOf("edit") > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "RGT")
        ) {
          this.disableBtn = true;
        }

        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")
        ) {
          this.disableBtn = true;
        }
      });
    }
    if (this.router.url.indexOf("process") > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.isLoading = true;
        this.applicationService.getById(params["id"]).subscribe((data: any) => {
          this.isDupApplication =
            data.permit_type.code ==
            this.authWebService.userData.Configurations.find(
              (x) => x.Code == "DupPermitAppCode1"
            ).Value;
          this.dataCntrl.application = data;
          this.dataCntrl.carrierID = data.carrier_id;
          this.dataCntrl.permit_type_id = data.permit_type_id;
          this.dataCntrl.permit = data.permits;
          this.dataCntrl.permittype = data.permit_type;
          this.dataCntrl.vehicles = data.vehicle;
          this.isLoading = false;
          this.utility.carrierStatusId = data.carrier.status_id;
          if (
            environment.authWebApi.userData.Roles.find(
              (p) => p.Code == "RGT" || p.Code == "ADMIN" || this.carrierId
            )
          ) {
            this.isProcess = true;
            this.dataCntrl.currentTab = "permitype";
            // this.ctrlData.currentTab = 'permitype';
            //this.getCarrier();
            this.showPage = true;
          }
        });
      });
    }
    this.onActive();
  }
  showMenu(dropdown) {
    this.showMenuBtn = !this.showMenuBtn;
  }
  getApp(id) {
    this.applicationService.getById(id).subscribe((data) => {
      //console.log(data);
      this.dataCntrl.application = data;
    });
  }
  getCarrier() {
    this.pageload = true;
    this.carrierService.getById(this.dataCntrl.carrierID).subscribe(
      (result) => {
        this.setCarrierData(result);
        this.pageload = false;
      },
      (error) => {
        this.pageload = false;
        //console.log(error);
      }
    );
    this.pageload = false;
  }

  setCarrierData(data) {
    data.account_balance =
      data.account_balance != 0
        ? this.currformat.transform(parseFloat(data.account_balance))
        : "R 0.00";
    this.dataCntrl.carrier = data;
    this.dataCntrl.application.carrier_id = data.id;
    this.dataCntrl.application.person_id = data.person_id;
  }
  cancel() {
    this.routr.navigateByUrl("permit/approval");
  }
  approve() {
    this.routr.navigateByUrl("permit/approval/correspondence");
  }
  tabChanged(tab) {
    this.dataCntrl.currentTab = tab;
    this.disableButtons();
    switch (tab) {
      case "permitype": {
        this.canSave = this.dataCntrl.permittypeSelected ? true : false;
        this.activeTab = tab;
        break;
      }
      case "vehicle": {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case "route": {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case "motivation": {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case "uploads": {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
    }
  }

  disableButtons() {
    this.canSave = false;
    this.canSubmit = false;
  }

  onStart() {
    this.saveApplication();
    this.canSave = true;
    this.dataCntrl.processStarted = true;
    this.disableTabs = this.dataCntrl.permittypeSelected ? false : true;
    this.activeTab = "vehicle";
    this.dataCntrl.currentTab = "vehicle";
  }

  onCancel() {
    if (
      this.dataCntrl.processStarted == true &&
      this.dataCntrl.application.id == undefined
    ) {
      this.showModal
        .showConfirm(
          "Cancel Application",
          "Are you sure you want to cancel?",
          `Your application has not been saved. If you continue to cancel without saving, you will loose all your data.`,
          "Yes",
          "No"
        )
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.router.navigateByUrl(
              `/carrier/permit/application/${this.dataCntrl.carrierID}`
            );
          } else {
            return;
          }
        });
    } else {
      this.router.navigateByUrl(
        `/carrier/permit/application/${this.dataCntrl.carrierID}`
      );
    }
  }

  onSave() {
    switch (this.dataCntrl.currentTab) {
      case "permitype": {
        if (this.dataCntrl.application.id == undefined) {
          this.saveApplication();
        } else {
          this.showModal.showAlert(
            "Save Application",
            "Application saved successfully"
          );
        }
        break;
      }
      case "vehicle": {
        this.saveVehicles();
        break;
      }
      case "route": {
        this.saveRoute();
        break;
      }
      case "motivation": {
        this.saveMotivation();
        break;
      }
      case "uploads": {
        if (this.dataCntrl.application.id == undefined) {
          this.saveApplication();
        } else {
          this.showModal.showAlert(
            "Save Application",
            "Application saved successfully"
          );
        }
        break;
      }
    }
  }

  saveApplication() {
    this.tabload = true;
    this.dataCntrl.application.date_modified =
      this.dataCntrl.application.date_created = new Date();
    this.dataCntrl.application.user_modified =
      this.dataCntrl.application.user_created = this.username;
    this.applicationService
      .postApplication(this.dataCntrl.application)
      .subscribe(
        (result: any) => {
          this.dataCntrl.application = result;
          this.dataCntrl.permit.permit_type_id = result.permit_type_id;
          this.dataCntrl.permit.application_id = result.id;
          this.savePermit();
        },
        (error) => {
          this.tabload = false;
          this.showModal.showError(
            "Save Application",
            "Failed to save application. If the problem persist, please contact system administrator.",
            error
          );

          return;
        }
      );
  }

  savePermit() {
    this.dataCntrl.permit.date_modified = this.dataCntrl.permit.date_created =
      new Date();
    this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created =
      this.username;
    this.dataCntrl.permit.permit_fee =
      this.dataCntrl.permittype.current_fee == null
        ? 0
        : this.dataCntrl.permittype.current_fee;
    this.dataCntrl.permit.application_fee =
      this.dataCntrl.permittype.current_application_fee == null
        ? 0
        : this.dataCntrl.permittype.current_application_fee;
    this.permitService.postPermit(this.dataCntrl.permit).subscribe(
      (result) => {
        this.dataCntrl.permit = result;
        this.tabload = false;
      },
      (error) => {
        this.tabload = false;
        this.showModal.showError(
          "Save Application",
          "Failed to save application. If the problem persist, please contact system administrator.",
          error
        );
        return;
      }
    );
  }

  saveVehicles() {
    this.tabload = true;
    this.dataCntrl.vehicles.forEach((element) => {
      element.permit_id = this.dataCntrl.permit.id;
      element.date_modified = element.date_created = new Date();
      element.user_modified = element.user_created = this.username;
    });
    if (this.dataCntrl.application.id == undefined) {
      this.saveApplication();
    } else {
      this.vehicleService.postVehicle(this.dataCntrl.vehicles).subscribe(
        (result) => {
          this.dataCntrl.vehicles = result;
          this.updateVehiclelist(result);
          ///this.toastr.success('Saved Step 1 Successfully','Step 1');
        },
        (error) => {
          this.tabload = false;
          this.showModal.showError(
            "Save Application",
            "Failed to save application. If the problem persist, please contact system administrator.",
            error
          );
          return;
        }
      );
    }
  }

  updateVehiclelist(data) {
    this.vehicleComp.listvehicles = data;
    this.tabload = false;
    //this.nextFrame();
  }

  saveRoute() {
    this.tabload = true;
    if (this.dataCntrl.application.id == undefined) {
      this.saveApplication();
    } else {
      this.applicationService
        .putApplication(this.dataCntrl.application)
        .subscribe(
          (result) => {
            this.dataCntrl.application = result;
            this.tabload = false;
            this.showModal.showAlert(
              "Save Application",
              "Route saved successfully"
            );
          },
          (error) => {
            this.tabload = false;
            this.showModal.showError(
              "Save Application",
              "Failed to save application. If the problem persist, please contact system administrator.",
              error
            );
            return;
          }
        );
    }
  }

  saveMotivation() {
    this.tabload = true;
    if (this.dataCntrl.application.id == undefined) {
      this.saveApplication();
    } else {
      this.applicationService
        .putApplication(this.dataCntrl.application)
        .subscribe(
          (result) => {
            this.dataCntrl.application = result;
            this.tabload = false;
            this.showModal.showAlert(
              "Save Application",
              "Motivation saved successfully"
            );
          },
          (error) => {
            //console.log(error)
            this.tabload = false;
            this.showModal.showError(
              "Save Application",
              "Failed to save application. If the problem persist, please contact system administrator.",
              error
            );
            return;
          }
        );
    }
  }
  onActive() {
    //this.iconCtrl = key;
    this.applicationService.getTab().subscribe((x) => {
      //console.log(x);
      if (x > 0) {
        this.utility.activeTab = x;
      }
    });
  }
  onActive1(tabNum) {
    if (Object.keys(this.dataCntrl.permittype).length > 0) {
      if (
        this.dataCntrl.permit.hasOwnProperty("application_id") &&
        this.dataCntrl.permit.application_id != null
      ) {
        this.applicationService.setTab(tabNum);
        this.onActive();
      } else {
        this.toastService.error("Please save and continue", "Permit Type");
      }
    } else {
      if (tabNum != 1) {
        this.toastService.error(
          "Please select your Permit Type ",
          "Permit Type"
        );
        this.applicationService.setTab(1);
        this.onActive();
        return false;
      }
    }
  }
  nextFrame = () => {
    this.utility.activeTab = 3;
    this.utility.confirmCtrl = true;
    this.iconCtrl = 3;
  };

  backToList() {
    if (environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")) {
      this.routr.navigate(["/admin-annual-compliance/list"]);
    } else if (this.carrierId) {
      this.routr.navigate([`/annual-compliance/list/${this.carrierId}`]);
    }
  }
}
